<div class="modal-header">
  <h5 class="modal-title" id="contactConfirmationModalTitle">{{ title }}</h5>
  @if (showCloseButton) {
    <button type="button" class="btn-close" (click)="onClose()" aria-label="Close"></button>
  }
</div>

<div class="modal-body">
  <p class="mb-3">{{ description }}</p>
  @if (confirmationCodeError()) {
    <div class="alert alert-danger mb-0">{{ confirmationCodeError() }}</div>
  }
</div>

<div class="modal-footer modal-footer-actions d-flex flex-wrap justify-content-end">
  @if (showMaybeLater) {
    <button type="button" class="btn btn-outline-secondary" (click)="onMaybeLater()" [disabled]="isConfirmingContact()">
      Magari dopo
    </button>
  }
  <button type="button" class="btn btn-primary" (click)="onConfirm()" [disabled]="isConfirmingContact()">
    @if (isConfirmingContact()) {
      Conferma in corso...
    } @else {
      Conferma
    }
  </button>
</div>
